<template lang="pug">
	.tab-box-content.box
		.sections
			slot(name='top')
			slot(name='bottom')
		.arrow-container
			.clickable-arrow
</template>

<script>
export default {
	name : 'tab-box-content'
};
</script>

<style scoped lang="scss">

.tab-box-content {
	display: flex;
	flex-flow: row nowrap;

	.sections {
		display: flex;
		justify-content: flex-start;
		flex-flow: column;
		width: 100%;

		.top {
			display: flex;
			flex-flow: row nowrap;
			text-overflow: ellipsis;

			.title {
				font-weight: 600;
				font-size: 18px;
				color: $input-color;
			}

			.sub-title {
				font-weight: 400;
				font-size: 18px;
				color: $input-color-faded;
				margin-left: 8px;
			}
		}

		.bottom {
			display: flex;
			flex-flow: row wrap;
			width: 100%;

			> * {
				margin-right: 20px;
			}

			[class^="icon"] {
				font-family: 'Poppins', sans-serif!important;
				display: flex;
				flex-flow: row nowrap;
				align-items: center;

				&::before {
					font-family: 'icomoon';
					margin-right: 5px;
				}
			}

			p {
				font-size: 14px;
			}
		}
	}

	.bubble {
		position: relative;
		width: 10px;
		height: 10px;
		margin-right: 14px;

		&::before {
			content: '';
			width: 10px;
			height: 10px;
			border: 4px solid darken( #c4c4c4, 10% );
			border-radius: 50%;
			background: #c4c4c4;
			position: absolute;
			top: 50%;
			transform: translateY( -50% );
		}

		&.active {

			&::before {
				border-color: $color-primary;
				background: rgba( $color-primary, .5 );
			}

			&+p {
				color: $color-primary;
			}
		}
	}

	.arrow-container {
		position: relative;

		.clickable-arrow {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate( -50%, -50% ) rotate( -90deg );

			&::before, &::after {
				background: $color-primary;
			}
		}
	}
}

</style>
